import React, { useEffect, useState, useContext, createContext } from 'react';
import Api from './Api';

export const DatabaseContext = createContext()

export const DatabaseProvider = ({ children }) => {
    const [history, setHistory] = useState([])
    const [pool, setPool] = useState(null)
    const [poolId, setPoolIdReal] = useState(null)

    const setPoolId = id => {
        if (id) {
            setPoolIdReal(id)
        }
    }

    const clearPool = () => {
        setPoolIdReal(null)
    }

    useEffect(async () => {
        if (poolId) {
            const { data } = await Api.getPool(poolId)

            setPool(data)
        } else {
            setPool(null)
        }
    }, [poolId])

    return <DatabaseContext.Provider
        value={{ history, setHistory, pool, setPoolId, clearPool, setPool }}>
        { children }
    </DatabaseContext.Provider>
}

export const usePools = () => useContext(DatabaseContext)
